import { render } from "./TagSuggestion.vue?vue&type=template&id=2370d386&scoped=true&ts=true"
import script from "./TagSuggestion.vue?vue&type=script&lang=ts"
export * from "./TagSuggestion.vue?vue&type=script&lang=ts"

import "./TagSuggestion.vue?vue&type=style&index=0&id=2370d386&lang=scss&scoped=true"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2370d386"]])

export default __exports__